export default "__VITE_ASSET__CHfHgjFX__"